import $ from 'jquery';
import _ from 'lodash';
import { EdgeResizer } from '~src/utils';
import { onTemplateChange } from '~src/sidebar/onTemplateChange';
import { isLoggedUserGlobalEditor } from '~src/user';
import { FEATURES, isFeatureEnabled } from '../features';

const htmlTemplatesByCategory = async (templates) => {
  const allowCreateVideos = await isFeatureEnabled(FEATURES.CREATE_VIDEOS);
  const allowModify = await isFeatureEnabled(FEATURES.CREATE_TEMPLATES);
  const allowClone = await isFeatureEnabled(FEATURES.CLONE_TEMPLATES);
  const isGlobalEditor = await isLoggedUserGlobalEditor();

  const { ids, html } = await templates.reduce(
    async (accA, item) => {
      const acc = await accA;
      if (item.animations && allowCreateVideos === false) {
        return acc;
      }

      let gifPreviewId;

      let preview;
      if (_.get(item, 'isGlobal', false) === true) {
        preview = _.get(
          item,
          'editor_templates_default_pages.edges[0].node.preview.url'
        );
        gifPreviewId = _.get(
          item,
          'editor_templates_default_pages.edges[0].node.gifPreviewId',
          ''
        );
      } else {
        preview = _.get(
          item,
          'editor_templates_pages.edges[0].node.preview.url'
        );
        gifPreviewId = _.get(
          item,
          'editor_templates_pages.edges[0].node.gifPreviewId',
          ''
        );
      }

      let previewImg;

      if (gifPreviewId) {
        previewImg = `${process.env.GIOTTO_VIDEO_CDN}/${gifPreviewId}`;
      } else if (preview) {
        // Use larger previews to better fill the enlarged grid
        previewImg = new EdgeResizer(preview).scaleToWidth(250);
      } else {
        previewImg = '/assets/blocks/placeholders/project-type.png';
      }

      const itemId = `editor-sidebar-set-canvas-template-${item.objectId}`;

      acc.html += `<div
                    class="sidebar-item-grid-box image-square-container grid-text-images">`;

      acc.html += `<div id="${itemId}" 
                        data-templates-item-id="${item.id}"
                        data-templates-item-is-global="${_.get(
                          item,
                          'isGlobal',
                          false
                        )}"
                        class="sidebar-item-grid-box-click-listener"></div>`;

      if (!$(`#${itemId}`).length) {
        acc.html += `
          <img
            src="../assets/svg/img-loader.gif"
            class="lazy image-square"
            data-src="${previewImg}"
          />`;
      } else {
        acc.html += `
          <img
            src="${previewImg}"
            class="image-square"
          />`;
      }

      if (_.get(item, 'isGlobal', false) === false) {
        if (item.name) {
          acc.html += `<div class="templates-name">${item.name}</diV>`;
        } else {
          acc.html += `<div class="templates-name">${item.metadata.templatesCategoryName} Personalizzato</diV>`;
        }
      } else {
        acc.html += '<div class="templates-name">&nbsp</div>';
      }

      acc.html += `<div class="${
        _.get(item, 'isGlobal', false) === false || isGlobalEditor || allowClone
          ? 'option-button-container sidebar-context-menu-trigger'
          : ''
      } bg-color-existing-canvas">
      <div class="option-button-container-relative">
          <div class="context-menu context-menu-child sidebar-context-menu bg-color-existing-canvas color-existing-canvas">`;
      if (allowClone) {
        acc.html += `<div class="item context-menu-child" data-giotto-duplicate-template="${item.objectId}">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"></path>
        </svg>
        Duplica
      </div>`;
      }

      if (_.get(item, 'isGlobal', false) === false || isGlobalEditor) {
        if (allowModify || isGlobalEditor) {
          acc.html += `<a href="/template-manager/${item.objectId}" data-navigo="">
          <div class="item context-menu-child">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
            </svg>
            Modifica
          </div>
        </a>`;
        }
        acc.html += `<div class="item context-menu-child" data-giotto-rename-template="${
          item.objectId
        }" data-giotto-isglobal="${_.get(item, 'isGlobal', false)}">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M18 13V5a2 2 0 00-2-2H4a2 2 0 00-2 2v8a2 2 0 002 2h3l3 3 3-3h3a2 2 0 002-2zM5 7a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1zm1 3a1 1 0 100 2h3a1 1 0 100-2H6z" clip-rule="evenodd" />
        </svg>
        Rinomina
      </div>
      `;
      }

      acc.html += '</div></div></div>';

      acc.html += '</div>';

      acc.ids.push(`#${itemId}`);

      return acc;
    },
    { ids: [], html: '' }
  );

  if (ids.length) {
    ids.forEach((id) => {
      $('body').off('click', id, onTemplateChange);
      $('body').on('click', id, onTemplateChange);
    });
  }
  return html;
};

const templateAddTemplates = async ({ items, allowNew }, categories) => {
  let html = '';

  const allowCreateVideos = await isFeatureEnabled(FEATURES.CREATE_VIDEOS);

  if (items.length === 0 && categories.items.length === 0) {
    html =
      '<div class="containerTextEmptyBox"><div class="textEmptyBox">Non ci sono modelli disponibili</div></div>';
  } else {
    const templatesSortedByCategories = _.orderBy(items, [
      'editor_templates_categories_default_pointer.order',
      'editor_templates_categories_pointer.order',
    ]);

    // for Each category
    // header category
    const templatesGroupedByCategories = _.groupBy(
      templatesSortedByCategories,
      'metadata.templatesCategoryName'
    );

    for (const category of categories.items) {
      const templatesGroupedByCategory =
        templatesGroupedByCategories[category.name];

      if (allowCreateVideos === false && category.name.includes('Video')) {
        continue;
      }

      let addNewBtn = allowNew
        ? `<button data-giotto-create-template data-giotto-create-template-category-id="${category.objectId}" class="btn btn-circle btn-sm float-right sidebar-category-button">Crea</button>`
        : '<button data-giotto-request-new-template class="btn btn-circle btn-sm float-right sidebar-category-button">Richiedi</button>';

      html += '<div class="pb-3">';
      html += '<div class="header-sidebar">';
      html += '<div class="header-category-sidebar">';
      html += `<div class="text-left sidebar-category-text">${
        categories.items.length > 1 ? category.name : ''
      }${addNewBtn}</div>`;
      html += '</div>';
      if (templatesGroupedByCategory) {
        html +=
          '<div class="items-container-grid editor-sidebar-pages-editable">';
        html += await htmlTemplatesByCategory(templatesGroupedByCategory);
        html += '</div></div>';
      } else {
        html +=
          '<p class="text-center text-muted mt-3">Nessun modello presente<p>';
      }
      html += '</div>';
    }
  }

  // Move the global action button into the header actions area
  if (categories.allowNew) {
    $('#templates-header-actions').html(
      '<button class="g-btn g-btn-outline g-btn-size-sm" data-giotto-create-template-category>Crea evento</button>'
    );
  } else {
    $('#templates-header-actions').html(
      '<button class="g-btn g-btn-outline g-btn-size-sm requestNewEvent" data-giotto-request-template-category>Richiedi evento</button>'
    );
  }

  $('#editor-sidebar-templates').html(html);
};

export const displaySidebarTemplates = async () => {
  const sidebarTemplates = _.get(window.editorConfig, 'sidebarTemplates', {
    items: [],
    allowNew: false,
  });

  const sidebarTemplateCategories = _.get(
    window.editorConfig,
    'sidebarTemplatesCategories',
    []
  );

  await templateAddTemplates(sidebarTemplates, sidebarTemplateCategories);

  window.lazyLoadInstance.update();
};
